module.exports = __webpack_public_path__ + "static/img/85093B_1_C_20210117_fit.0925049.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85093B_1_C_20210117_fit.png
// module id = RCXE
// module chunks = 0